module.exports = __webpack_public_path__ + "img/login-logo.5c7cbefa.svg";